import { put, takeLatest, all, select } from 'redux-saga/effects';
import { quotationsLoaded, filtersLoaded } from './actions';
import {
  GET_QUOTATIONS,
  LOAD_FILTERS,
  UPDATE_SORT,
  REMOVE_ALL,
  REMOVE_FILTER,
  SEARCH_QUOTATIONS,
  SET_PAGE_NUMBER,
  DOWNLOAD_QUOTATIONS,
} from './constants';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';
import { makeSelectQuotationsRequest, makeSelectQuotationsParameters } from './selectors';

function* fetchQuotations() {
  const requestURL = `${process.env.API_URL}quotations`;
  const requestBody = yield select(makeSelectQuotationsRequest());
  try {
    const parameters = {
      method: 'POST',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(requestBody),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield put(
      quotationsLoaded(
        request.items.data,
        request.total,
        request.lastPage,
        request.currentPage,
      ),
    );
  } catch (err) {
    console.log('request error', err);
  }
}

function* fetchFilters() {
  const requestURL = `${process.env.API_URL}quotations/filters`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };
    const response = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield put(filtersLoaded(response));
  } catch (error) {
    console.log('request error', error);
  }
}

function* downloadQuotations() {
  const requestURL = `${process.env.API_URL}quotations/export`;
  const requestBody = yield select(makeSelectQuotationsRequest());

  try {
    const parameters = {
      method: 'POST',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(requestBody),
    };

    yield fetch(requestURL, parameters)
      .then(response => response.blob())
      .then(blob => download(blob, `Preventivi.xlsx`));
  } catch (error) {
    console.log('request error', error);
  }
}

function* actionWatcher() {
  yield takeLatest(LOAD_FILTERS, fetchFilters);
  yield takeLatest(DOWNLOAD_QUOTATIONS, downloadQuotations);
  yield takeLatest(
    [
      GET_QUOTATIONS,
      UPDATE_SORT,
      REMOVE_ALL,
      REMOVE_FILTER,
      SEARCH_QUOTATIONS,
      SET_PAGE_NUMBER,
    ],
    fetchQuotations,
  );
}

export default function* quotationsData() {
  yield all([actionWatcher()]);
}
